var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-success",class:{
    'show': _vm.orderSuccessVisible,
    'heightFootBottom': _vm.isHeightFoot,
}},[_c('div',[_vm._v("点歌成功")])])}
var staticRenderFns = []

export { render, staticRenderFns }